import { forwardRef, SVGProps, ForwardRefExoticComponent, RefAttributes } from 'react';

const defaultAttributes = {
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 0,
};

export type SVGAttributes = Partial<SVGProps<SVGSVGElement>>
type ComponentAttributes = RefAttributes<SVGSVGElement> & SVGAttributes

export interface IconProps extends ComponentAttributes {
  size?: string | number;
}

export type IconType = ForwardRefExoticComponent<IconProps>;

export const toKebabCase = (string: string) => string.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

const createIcon = (iconName: string, createSVG: (props: IconProps) => React.ReactNode): IconType => {
  const Component = forwardRef<SVGSVGElement, IconProps>(
    ({ color = 'currentColor', size = 16, strokeWidth = 0, className = '', style = {}, ...rest }, ref) => (createSVG({
      ref,
      ...defaultAttributes,
      width: size,
      height: size,
      color: color,
      stroke: color,
      strokeWidth,
      style: {
        display: 'inline-block',
        ...style
      },
      className: [
        `findin-icon findin-icon-${toKebabCase(iconName)}`,
        className
      ].filter(Boolean).join(' '),
      ...rest,
    }))

  );

  Component.displayName = `${iconName}Icon`;

  return Component;
};

export default createIcon;